export enum MeasuringUnitType {
    FeetAndInches = 1,
    Meter
}